(function () {
  const sliderSelector =
    '[data-fc-card-slider]';

  function initialiseSlider(slider) {
    if (
      slider.dataset.fcSliderReady ===
      'true'
    ) {
      return;
    }

    const track = slider.querySelector(
      '[data-fc-card-slider-track]'
    );

    const dots = slider.querySelectorAll(
      '[data-fc-card-slider-dot]'
    );

    const card = slider.closest(
      '.product-card-wrapper'
    );

    const swatches = card
      ? card.querySelectorAll(
          '[data-fc-card-swatch]'
        )
      : [];

    if (!track) return;

    const originalSwatch =
  Array.from(swatches).find((swatch) =>
    swatch.classList.contains('is-active')
  ) || swatches[0] || null;

const originalSlides =
  Array.from(
    track.querySelectorAll(
      '[data-fc-card-slider-slide]'
    )
  ).map((slide) => ({
    html: slide.innerHTML,
    video: slide.querySelector(
      '.fc-card-slider__video'
    ),
    hidden: slide.hidden,
  }));

const originalDotStates =
  Array.from(dots).map((dot) => ({
    hidden: dot.hidden,
  }));

    slider.dataset.fcSliderReady = 'true';

    let scrollFrame;
    let loopResetTimer;
    let resizeFrame;
    let activeDotIndex = 0;
    let videoObserver = null;

    let isDragging = false;
    let dragStartX = 0;
    let dragStartY = 0;
    let dragStartScrollLeft = 0;
    let dragDirection = null;

    function reduceMotion() {
      return window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;
    }
    function setupVideos() {
  if (videoObserver) {
    videoObserver.disconnect();
  }

  const videos = Array.from(
    track.querySelectorAll(
      '.fc-card-slider__video'
    )
  );

  if (!videos.length) return;

  function playVideo(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    video.setAttribute('muted', '');
    video.setAttribute(
      'playsinline',
      ''
    );

    const playPromise = video.play();

    if (
      playPromise &&
      typeof playPromise.catch ===
        'function'
    ) {
      playPromise.catch(() => {
        video.addEventListener(
          'canplay',
          () => {
            video.play().catch(() => {});
          },
          { once: true }
        );
      });
    }
  }

  const activeSlide =
  getRealSlides()[activeDotIndex];

const activeVideo = activeSlide
  ? activeSlide.querySelector(
      '.fc-card-slider__video'
    )
  : null;

if (activeVideo) {
  playVideo(activeVideo);
}

  if (
    'IntersectionObserver' in window
  ) {
    videoObserver =
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;

            if (
              entry.isIntersecting &&
              entry.intersectionRatio >= 0.1
            ) {
              playVideo(video);
            } else {
              video.pause();
            }
          });
        },
        {
          threshold: [0, 0.1, 1],
        }
      );

    videos.forEach((video) => {
      videoObserver.observe(video);
    });
  } else {
    videos.forEach(playVideo);
  }
}

    function getVariantImages(swatch) {
      return (
        swatch.dataset.variantImages ||
        swatch.dataset.variantImage ||
        ''
      )
        .split('||')
        .map((imageUrl) =>
          imageUrl.trim()
        )
        .filter(Boolean)
        .slice(0, 4);
    }

    function getRealSlides() {
      return Array.from(
        track.querySelectorAll(
          '[data-fc-card-slider-slide]:not([hidden])'
        )
      );
    }

    function getVisibleSlideCount() {
      return getRealSlides().length;
    }

    function removeLoopClones() {
      track
        .querySelectorAll(
          '[data-fc-card-slider-loop-clone]'
        )
        .forEach((clone) =>
          clone.remove()
        );
    }

    function jumpToPhysicalIndex(
  index,
  attempt = 0
) {
  if (!track.clientWidth) {
    if (attempt < 15) {
      window.requestAnimationFrame(
        () => {
          jumpToPhysicalIndex(
            index,
            attempt + 1
          );
        }
      );
    }

    return;
  }

  const previousScrollBehavior =
    track.style.scrollBehavior;

  track.style.scrollBehavior = 'auto';

  track.scrollLeft =
    index * track.clientWidth;

  window.requestAnimationFrame(() => {
    track.style.scrollBehavior =
      previousScrollBehavior;

    setupVideos();
  });
}
    function getPhysicalIndexForLogical(
      logicalIndex
    ) {
      const slideCount =
        getVisibleSlideCount();

      if (slideCount <= 1) {
        return 0;
      }

      return logicalIndex + 1;
    }

    function getLogicalIndexFromPhysical(
      physicalIndex
    ) {
      const slideCount =
        getVisibleSlideCount();

      if (slideCount <= 1) {
        return 0;
      }

      if (physicalIndex <= 0) {
        return slideCount - 1;
      }

      if (
        physicalIndex >=
        slideCount + 1
      ) {
        return 0;
      }

      return physicalIndex - 1;
    }

    function buildLoopClones() {
      removeLoopClones();

      const realSlides = getRealSlides();

      if (realSlides.length <= 1) {
        jumpToPhysicalIndex(0);
        return;
      }

      const firstSlide =
        realSlides[0];

      const lastSlide =
        realSlides[
          realSlides.length - 1
        ];

      const firstClone =
        firstSlide.cloneNode(true);

      const lastClone =
        lastSlide.cloneNode(true);

      firstClone.removeAttribute(
        'data-fc-card-slider-slide'
      );

      lastClone.removeAttribute(
        'data-fc-card-slider-slide'
      );

      firstClone.setAttribute(
        'data-fc-card-slider-loop-clone',
        'first'
      );

      lastClone.setAttribute(
        'data-fc-card-slider-loop-clone',
        'last'
      );

      firstClone.setAttribute(
        'aria-hidden',
        'true'
      );

      lastClone.setAttribute(
        'aria-hidden',
        'true'
      );

      track.insertBefore(
        lastClone,
        realSlides[0]
      );

      track.appendChild(firstClone);

      window.requestAnimationFrame(() => {
        jumpToPhysicalIndex(
          getPhysicalIndexForLogical(
            activeDotIndex
          )
        );
      });
    }

    function setActiveDot(index) {
      const slideCount =
        getVisibleSlideCount();

      activeDotIndex = Math.max(
        0,
        Math.min(
          index,
          Math.max(0, slideCount - 1)
        )
      );

      dots.forEach(
        (dot, dotIndex) => {
          const isActive =
            !dot.hidden &&
            dotIndex ===
              activeDotIndex;

          dot.classList.toggle(
            'is-active',
            isActive
          );

          dot.setAttribute(
            'aria-current',
            isActive ? 'true' : 'false'
          );
        }
      );
    }

    function resetLoopPosition() {
      const slideCount =
        getVisibleSlideCount();

      if (
        slideCount <= 1 ||
        !track.clientWidth
      ) {
        return;
      }

      const physicalIndex =
        Math.round(
          track.scrollLeft /
            track.clientWidth
        );

      if (physicalIndex <= 0) {
        jumpToPhysicalIndex(
          slideCount
        );

        setActiveDot(
          slideCount - 1
        );
      } else if (
        physicalIndex >=
        slideCount + 1
      ) {
        jumpToPhysicalIndex(1);
        setActiveDot(0);
      }
    }

    function preloadVariantImage(swatch) {
      if (
        swatch.dataset
          .fcVariantPreloaded ===
        'true'
      ) {
        return;
      }

      const variantImages =
        getVariantImages(swatch);

      if (!variantImages.length) {
        return;
      }

      swatch.dataset.fcVariantPreloaded =
        'true';

      const preloadImage =
        new Image();

      preloadImage.decoding = 'async';
      preloadImage.src =
        variantImages[0];

      swatch.fcPreloadedImage =
        preloadImage;
    }

    function preloadAllVariantImages() {
      swatches.forEach(
        preloadVariantImage
      );
    }

    if (swatches.length) {
      if (
        'IntersectionObserver' in window
      ) {
        const variantObserver =
          new IntersectionObserver(
            (entries) => {
              const isVisible =
                entries.some(
                  (entry) =>
                    entry.isIntersecting
                );

              if (isVisible) {
                preloadAllVariantImages();
                variantObserver.disconnect();
              }
            },
            {
              rootMargin: '400px',
            }
          );

        variantObserver.observe(slider);
      } else {
        preloadAllVariantImages();
      }
    }

    dots.forEach((dot, index) => {
      dot.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (dot.hidden) return;

          const physicalIndex =
            getPhysicalIndexForLogical(
              index
            );

          track.scrollTo({
            left:
              physicalIndex *
              track.clientWidth,
            behavior: reduceMotion()
              ? 'auto'
              : 'smooth',
          });

          setActiveDot(index);
        }
      );
    });

    track.addEventListener(
      'scroll',
      () => {
        window.cancelAnimationFrame(
          scrollFrame
        );

        scrollFrame =
          window.requestAnimationFrame(
            () => {
              if (!track.clientWidth) {
                return;
              }

              const physicalIndex =
                Math.round(
                  track.scrollLeft /
                    track.clientWidth
                );

              const logicalIndex =
                getLogicalIndexFromPhysical(
                  physicalIndex
                );

              setActiveDot(
                logicalIndex
              );

              window.clearTimeout(
                loopResetTimer
              );

              loopResetTimer =
                window.setTimeout(
                  resetLoopPosition,
                  120
                );
            }
          );
      },
      {
        passive: true,
      }
    );

    if ('onscrollend' in window) {
      track.addEventListener(
        'scrollend',
        resetLoopPosition
      );
    }
    let productTapStartX = 0;
let productTapStartY = 0;
let productTapMoved = false;

track.addEventListener(
  'pointerdown',
  (event) => {
    productTapStartX =
      event.clientX;

    productTapStartY =
      event.clientY;

    productTapMoved = false;
  },
  {
    passive: true,
  }
);

track.addEventListener(
  'pointermove',
  (event) => {
    const movedX = Math.abs(
      event.clientX -
        productTapStartX
    );

    const movedY = Math.abs(
      event.clientY -
        productTapStartY
    );

    if (
      movedX > 8 ||
      movedY > 8
    ) {
      productTapMoved = true;
    }
  },
  {
    passive: true,
  }
);

track.addEventListener(
  'pointercancel',
  () => {
    productTapMoved = true;
  }
);

track.addEventListener(
  'click',
  (event) => {
    if (productTapMoved) {
      event.preventDefault();
      event.stopPropagation();
      productTapMoved = false;
      return;
    }

    if (
      event.target.closest(
        'button, a, input, select, textarea'
      )
    ) {
      return;
    }

    const productUrl =
      track.dataset.productUrl;

    if (!productUrl) return;

    event.preventDefault();
    event.stopPropagation();

    window.location.assign(
      productUrl
    );
  }
);

track.addEventListener(
  'keydown',
  (event) => {
    if (event.key !== 'Enter') {
      return;
    }

    const productUrl =
      track.dataset.productUrl;

    if (!productUrl) return;

    event.preventDefault();

    window.location.assign(
      productUrl
    );
  }
);
    track.addEventListener(
      'pointerdown',
      (event) => {
        if (
          event.pointerType !== 'mouse' ||
          event.button !== 0
        ) {
          return;
        }

        isDragging = true;
        dragStartX = event.clientX;
        dragStartY = event.clientY;
        dragStartScrollLeft =
          track.scrollLeft;
        dragDirection = 'horizontal';

        track.classList.add(
          'is-dragging'
        );

        track.setPointerCapture(
          event.pointerId
        );
      }
    );

    track.addEventListener(
      'pointermove',
      (event) => {
        if (!isDragging) return;

        const distanceX =
          event.clientX - dragStartX;

        const distanceY =
          event.clientY - dragStartY;

        if (
          !dragDirection &&
          (Math.abs(distanceX) > 6 ||
            Math.abs(distanceY) > 6)
        ) {
          dragDirection =
            Math.abs(distanceX) >
            Math.abs(distanceY)
              ? 'horizontal'
              : 'vertical';
        }

        if (
          dragDirection !== 'horizontal'
        ) {
          return;
        }

        event.preventDefault();

        track.scrollLeft =
          dragStartScrollLeft -
          distanceX;
      }
    );

    function finishDragging(event) {
      if (!isDragging) return;

      isDragging = false;

      track.classList.remove(
        'is-dragging'
      );

      if (
        track.hasPointerCapture(
          event.pointerId
        )
      ) {
        track.releasePointerCapture(
          event.pointerId
        );
      }

      if (
        dragDirection !== 'horizontal'
      ) {
        dragDirection = null;
        return;
      }

      const slideCount =
        getVisibleSlideCount();

      const maximumPhysicalIndex =
        slideCount > 1
          ? slideCount + 1
          : 0;

      const physicalIndex = Math.max(
        0,
        Math.min(
          Math.round(
            track.scrollLeft /
              track.clientWidth
          ),
          maximumPhysicalIndex
        )
      );

      track.scrollTo({
        left:
          physicalIndex *
          track.clientWidth,
        behavior: reduceMotion()
          ? 'auto'
          : 'smooth',
      });

      setActiveDot(
        getLogicalIndexFromPhysical(
          physicalIndex
        )
      );

      dragDirection = null;
    }

    track.addEventListener(
      'pointerup',
      finishDragging
    );

    track.addEventListener(
      'pointercancel',
      finishDragging
    );

    swatches.forEach((swatch) => {
      swatch.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (swatch === originalSwatch) {
  removeLoopClones();

  const currentSlides =
    Array.from(
      track.querySelectorAll(
        '[data-fc-card-slider-slide]'
      )
    );

  currentSlides.forEach(
    (slide, slideIndex) => {
      const originalSlide =
        originalSlides[slideIndex];

      if (!originalSlide) return;

      if (originalSlide.video) {
  slide.replaceChildren(
    originalSlide.video
  );

  originalSlide.video.muted = true;
  originalSlide.video.defaultMuted = true;
  originalSlide.video.playsInline = true;

  originalSlide.video.setAttribute(
    'muted',
    ''
  );

  originalSlide.video.setAttribute(
    'playsinline',
    ''
  );
} else {
  slide.innerHTML =
    originalSlide.html;
}

slide.hidden =
  originalSlide.hidden;
    }
  );

  dots.forEach((dot, dotIndex) => {
    const originalDot =
      originalDotStates[dotIndex];

    dot.hidden = originalDot
      ? originalDot.hidden
      : false;
  });

  activeDotIndex = 0;
  setActiveDot(0);
  buildLoopClones();

  window.requestAnimationFrame(
    setupVideos
  );

  swatches.forEach((item) => {
    const isActive =
      item === swatch;

    item.classList.toggle(
      'is-active',
      isActive
    );

    item.setAttribute(
      'aria-pressed',
      isActive ? 'true' : 'false'
    );
  });

  return;
}

          const variantImages =
            getVariantImages(swatch);

          if (!variantImages.length) {
            return;
          }

          removeLoopClones();

          const slides = Array.from(
            track.querySelectorAll(
              '[data-fc-card-slider-slide]'
            )
          );

          const availableImageCount =
            Math.min(
              variantImages.length,
              slides.length
            );

          if (!availableImageCount) {
            return;
          }

          variantImages
            .slice(
              0,
              availableImageCount
            )
            .forEach(
              (
                variantImage,
                imageIndex
              ) => {
                const slide =
                  slides[imageIndex];

                let image =
  slide.querySelector(
    'img'
  );

if (!image) {
  return;
}

slide.hidden = false;

                image.removeAttribute(
                  'srcset'
                );

                image.sizes = `${Math.max(
                  Math.ceil(
                    track.clientWidth
                  ),
                  320
                )}px`;

                image.decoding = 'async';

                image.loading =
                  imageIndex === 0
                    ? 'eager'
                    : 'lazy';

                image.src = variantImage;

                const variantAlt =
                  swatch.dataset
                    .variantImageAlt ||
                  swatch.getAttribute(
                    'aria-label'
                  ) ||
                  '';

                image.alt =
                  `${variantAlt} - image ${
                    imageIndex + 1
                  }`;
              }
            );

          slides.forEach((slide) => {
  slide.hidden = false;
});

          dots.forEach((dot) => {
  dot.hidden = false;
});

          activeDotIndex = 0;
          setActiveDot(0);

          buildLoopClones();
          window.requestAnimationFrame(
  setupVideos
);

          swatches.forEach((item) => {
            const isActive =
              item === swatch;

            item.classList.toggle(
              'is-active',
              isActive
            );

            item.setAttribute(
              'aria-pressed',
              isActive
                ? 'true'
                : 'false'
            );
          });
        }
      );
    });

    buildLoopClones();
window.requestAnimationFrame(
  setupVideos
);
    if ('ResizeObserver' in window) {
      const resizeObserver =
        new ResizeObserver(() => {
          window.cancelAnimationFrame(
            resizeFrame
          );

          resizeFrame =
            window.requestAnimationFrame(
              () => {
                jumpToPhysicalIndex(
                  getPhysicalIndexForLogical(
                    activeDotIndex
                  )
                );
              }
            );
        });

      resizeObserver.observe(track);
    }
  }

  function initialiseAll(root) {
    if (
      root.matches &&
      root.matches(sliderSelector)
    ) {
      initialiseSlider(root);
    }

    if (root.querySelectorAll) {
      root
        .querySelectorAll(
          sliderSelector
        )
        .forEach(initialiseSlider);
    }
  }

  function start() {
    initialiseAll(document);

    new MutationObserver(
      (mutations) => {
        mutations.forEach(
          (mutation) => {
            mutation.addedNodes.forEach(
              (node) => {
                if (
                  node.nodeType === 1
                ) {
                  initialiseAll(node);
                }
              }
            );
          }
        );
      }
    ).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true,
      }
    );
  } else {
    start();
  }
})();
